export default [
    {
        id: 1,
        label: {
            en: 'Pending',
            et: 'Läbivaatamisel',
            ru: 'На рассмотрении',
            lv: "Izskatīšanā",
            lt: "Peržiūrima",
            fi: "Käsiteltävänä",
        },
        // color: 'green',
        color: 'yellow',
    },
    {
        id: 3,
        label: {
            en: 'Approved',
            et: 'Kinnitatud',
            ru: 'Одобрено',
            lv: "Apstiprināts",
            lt: "Patvirtinta",
            fi: "Hyväksytty",
        },
        // color: 'blue',
        color: 'dark-blue'
    },
    {
        id: 5,
        label: {
            en: 'Rejected',
            et: 'Tagasi lükatud',
            ru: 'Отклонено',
            lv: "Noraidīts",
            lt: "Atmesta",
            fi: "Hylätty",
        },
        color: 'red'
    },
]